import React, { FC } from 'react'
import { Icon, Card } from 'components/common'
import { price } from 'lib/str-formatter'
import { colors } from 'lib/colors'

type Props = {
  cancellationFee: number
  cancelReason: string
}

const BookingCancelCard: FC<Props> = ({ cancellationFee, cancelReason }) => {
  return (
    <Card shadow style={{ border: `1px solid ${colors.KUCHINASHI}` }}>
      <div className="text-2xl font-bold space-x-2 mb-8">
        <Icon.InfoCircleTwoTone twoToneColor={colors.KUCHINASHI} />
        <span>この予約はキャンセル済みです</span>
      </div>
      <div className="grid grid-cols-2 gap-y-4 px-4">
        <div>キャンセル料金</div>
        <div className="text-right">{price(cancellationFee)}</div>
        <div>キャンセル理由</div>
        <div className="text-right">{cancelReason}</div>
      </div>
    </Card>
  )
}

export default BookingCancelCard
